// PostHog (lazy, only when VITE_POSTHOG_KEY is set). Events (§4.3): onboarding steps, sessions,
// rank per day, rekt, actions per day, ad impressions. Never PII beyond the account id.
import { clientEnv } from "./env";
import { anonId } from "./identity";

type Props = Record<string, string | number | boolean | null | undefined>;
let ph: { capture(e: string, p?: Props): void; identify(id: string): void } | null = null;
const queue: [string, Props?][] = [];

export async function initTelemetry() {
  if (!clientEnv.posthogKey) return;
  const { default: posthog } = await import("posthog-js");
  posthog.init(clientEnv.posthogKey, { api_host: clientEnv.posthogHost, autocapture: false, capture_pageview: true, persistence: "localStorage", bootstrap: { distinctID: anonId } });
  ph = posthog as unknown as typeof ph;
  for (const [e, p] of queue.splice(0)) ph!.capture(e, p);
}

export function track(event: string, props?: Props) {
  if (!clientEnv.posthogKey) return;
  if (ph) ph.capture(event, props);
  else if (queue.length < 200) queue.push([event, props]);
}

export function identify(userId: string) {
  ph?.identify(userId);
}
